import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useUser } from "@/context/UserContext";
import trpc from "@/shared/utils/trpc";
import {
  EXHIBITOR_INQUIRY_COUNT_REFRESH_EVENT,
  exhibitorInquiryExpoSlugFromPath,
  markExhibitorInquiryExpoSeen,
  readExhibitorInquiryLastSeenBySlug,
} from "@/pages/my-expos/exhibitorInquiries.const";

export function useExhibitorInquiryUnseenCount(enabled: boolean) {
  const { userDetails } = useUser();
  const location = useLocation();
  const [count, setCount] = useState(0);
  const userId = userDetails?.id;
  const expoSlug = exhibitorInquiryExpoSlugFromPath(location.pathname);

  const refresh = useCallback(async () => {
    if (!enabled || !userId) {
      setCount(0);
      return;
    }
    if (expoSlug) {
      markExhibitorInquiryExpoSeen(userId, expoSlug);
    }
    try {
      const res = await trpc.expo.getMyExhibitorInquiryUnseenCount.query({
        lastSeenBySlug: readExhibitorInquiryLastSeenBySlug(userId),
      });
      setCount(res.count);
    } catch (err) {
      console.error("Failed to load exhibitor inquiry count:", err);
    }
  }, [enabled, userId, expoSlug]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  useEffect(() => {
    const onRefresh = () => {
      void refresh();
    };
    window.addEventListener(EXHIBITOR_INQUIRY_COUNT_REFRESH_EVENT, onRefresh);
    return () => window.removeEventListener(EXHIBITOR_INQUIRY_COUNT_REFRESH_EVENT, onRefresh);
  }, [refresh]);

  return count;
}
